import app from '../app';
import Component from '../../common/Component';
import ItemList from '../../common/utils/ItemList';
import Alert from '../../common/components/Alert';
import Button from '../../common/components/Button';
import Icon from '../../common/components/Icon';
export default class Notices extends Component {
  loading = false;
  sent = false;
  view() {
    return m("div", {
      className: "App-notices"
    }, this.items().toArray());
  }
  items() {
    const items = new ItemList();
    const user = app.session.user;
    if (user && !user.isEmailConfirmed()) {
      items.add('emailConfirmation', m(Alert, {
        dismissible: false,
        controls: [m(Button, {
          className: "Button Button--link",
          onclick: this.onclickEmailConfirmation.bind(this),
          loading: this.loading,
          disabled: this.sent
        }, this.sent ? [m(Icon, {
          name: 'fas fa-check'
        }), ' ', app.translator.trans('core.forum.user_email_confirmation.sent_message')] : app.translator.trans('core.forum.user_email_confirmation.resend_button'))],
        className: "Alert--emailConfirmation",
        containerClassName: "container"
      }, app.translator.trans('core.forum.user_email_confirmation.alert_message', {
        email: m("strong", null, user.email())
      })), 100);
    }
    if (app.data.bisecting) {
      items.add('bisecting', m(Alert, {
        type: "error",
        dismissible: false,
        className: "Alert--bisecting",
        containerClassName: "container",
        controls: [m("a", {
          className: "Button Button--link",
          target: "_blank",
          href: app.forum.attribute('adminUrl') + '#/advanced?modal=extension-bisect'
        }, app.translator.trans('core.lib.notices.bisecting_continue'))]
      }, app.translator.trans('core.lib.notices.bisecting')), 90);
    }
    if (app.data.maintenanceMode) {
      items.add('maintenanceMode', m(Alert, {
        type: "error",
        dismissible: false,
        className: "Alert--maintenanceMode",
        containerClassName: "container"
      }, app.translator.trans('core.lib.notices.maintenance_mode_' + app.data.maintenanceMode)), 80);
    }
    return items;
  }
  onclickEmailConfirmation() {
    const user = app.session.user;
    this.loading = true;
    m.redraw();
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/users/' + user.id() + '/send-confirmation'
    }).then(() => {
      this.loading = false;
      this.sent = true;
      m.redraw();
    }).catch(() => {
      this.loading = false;
      m.redraw();
    });
  }
}
flarum.reg.add('core', 'forum/components/Notices', Notices);